import {
    VUE_APP_VIMEO_FOLDER_ID,
    VUE_APP_UPLOAD_PREFIX,
    VUE_APP_VIMEO_ACCESS_TOKEN, API_URL
} from '@/config';

//let Vimeo = require('vimeo').Vimeo;
//let client = new Vimeo(VUE_APP_VIMEO_ID, VUE_APP_VIMEO_APP_SECRET, VUE_APP_VIMEO_ACCESS_TOKEN);

import * as tus from 'tus-js-client';
import Vue from "vue";

/**
 *
 */
export const videoUpload = {

    namespaced: true,

    state: {
        video: {
            file: undefined,
            name: 'Untitled',
            description: 'Video description'
        },

        uploaded: 0,
        total: 0,
        percentage: 0,
        uploadStarted: false,
        activeParticipationUpload: null,

        transcodeStatus: {}
    },

    getters: {
        video: state => state.video,
        videoFile: state => state.video.file,
        videoName: state => state.video.name,
        videoDescription: state => state.video.description,
        fileInputText: state => state.fileInputText,
        percentage: state => state.percentage,
        uploadStarted: state => state.uploadStarted,
        activeParticipationUpload: state => state.activeParticipationUpload,
        transcodeStatus: state => state.transcodeStatus
    },

    mutations: {
        setVideoFile: (state, videoFile) => state.videoFile = videoFile,
        setVideoName: (state, videoName) => state.video.name = videoName,
        setVideodescription: (state, videoDescription) => state.video.description = videoDescription,
    },

    actions: {

        setVideo: async ({commit}, file) => {
            commit('setVideoFile', file);
            commit('setVideoName', file.name);
        },


        clearUpload: async function ({state,rootState}, data) {
            let participation = data.participation;
            let type = data.type;
            console.log(state.video, participation)
            const result = await Vue.axios.put(API_URL + type + 's/' + participation.id, {
                video_upload_link: null,
                video_id: null
            }, {
                headers: {token: rootState.token},
            });
            if (result) {
                participation.video_upload_link = null
            }
        },

        requestDownloadLink: async function ({state} ,data){
            let participation = data.participation;
            console.log(state)
            console.log(participation)
                //TODO:also remove from vimeo
                let videoGetLink = Vue.axios.create();
                delete videoGetLink.defaults.headers.common['Access-Token'];
                delete videoGetLink.defaults.headers.common['x-api-key'];
                delete videoGetLink.defaults.headers.common['X-CSRF-TOKEN'];
                delete videoGetLink.defaults.headers.common['X-Requested-With'];
                let id = participation.video_download_link
                    .split('?')[0]
                    .split('/')
                    .pop() ;
                let res = await videoGetLink({
                    method: 'GET',
                    url: 'https://api.vimeo.com/me/videos/' + id,
                    headers: {
                        Authorization: 'bearer ' + VUE_APP_VIMEO_ACCESS_TOKEN,
                        Accept: 'application/vnd.vimeo.*+json;version=3.4',
                        'Content-Type': 'application/json'
                    }
                });
                console.log('dllink from vimeo',res)
                if (res.status == 200) {
                    return res.data.link;
                }
        },

        removeVideo: async function ({state,rootState}, data) {
            let participation = data.participation;
            let type = data.type;
            let result;
            if (type == 'session') {
                result = await Vue.axios.put(API_URL + type + 's/' + participation.id, {
                    ondemand_link: null,
                }, {
                    headers: {token: rootState.token},
                });
            }
            if (type == 'presentation') {
                result = await Vue.axios.put(API_URL + type + 's/' + participation.id, {
                    video_link: null,
                }, {
                    headers: {token: rootState.token},
                });
            }
            if (result) {
                //TODO:also remove from vimeo
                /*let videoCreate = Vue.axios.create();
                delete videoCreate.defaults.headers.common['Access-Token'];
                delete videoCreate.defaults.headers.common['x-api-key'];
                delete videoCreate.defaults.headers.common['X-CSRF-TOKEN'];
                delete videoCreate.defaults.headers.common['X-Requested-With'];

                let id = type == 'session' ? participation.ondemand_link
                    .split('?')[0]
                    .split('/')
                    .pop() : participation.video_link
                    .split('?')[0]
                    .split('/')
                    .pop() ;
                let res = await videoCreate({
                    method: 'DELETE',
                    url: 'https://api.vimeo.com/videos/' + id,
                    headers: {
                        Authorization: 'bearer ' + VUE_APP_VIMEO_ACCESS_TOKEN,
                        Accept: 'application/vnd.vimeo.*+json;version=3.4',
                        'Content-Type': 'application/json'
                    }
                });
                if (res.status == 204) {*/
                    participation.video_link = null;
                    participation.ondemand_link = null;
                    state.percentage = 0;
                    state.uploaded = 0;
                    state.total = 0;
                    state.uploadStarted = false;
                //}
            }
        },

        async submitFileWithTus({state, rootState}, data) {

            let participation = data.participation;
            let type = data.type;
            var file = state.videoFile;
            state.uploadStarted = true;
            //console.log(file);
            state.activeParticipationUpload = participation.id

            console.log(API_URL, type, participation.code, rootState)

            let vimeoAxios = Vue.axios.create();
            delete vimeoAxios.defaults.headers.common['Access-Token'];
            delete vimeoAxios.defaults.headers.common['x-api-key'];
            delete vimeoAxios.defaults.headers.common['Access-Control-Allow-Methods'];
            let vimeoHeaders = {
                Authorization: 'Bearer ' + VUE_APP_VIMEO_ACCESS_TOKEN,
                'Content-Type': 'application/json',
                Accept: 'application/vnd.vimeo.*+json;version=3.4'
            };
            let videoId = null;
            let linkToSaveInPlanner = null;
            let upload_link = null

            if (!participation.video_upload_link) {
                let res = await vimeoAxios.post(
                    'https://api.vimeo.com/me/videos',
                    {
                        upload: {
                            approach: 'tus',
                            size: file.size
                        },
                        name: VUE_APP_UPLOAD_PREFIX + 'od_' + participation.id,
                        description:
                            'Uploaded Video for presentation: id:' + participation.id + ')',
                        privacy: {
                            embed: 'public'
                        }
                    },
                    {
                        headers: vimeoHeaders
                    }
                );
                console.log(res);

                videoId = res.data.uri.split('/').pop();
                linkToSaveInPlanner =
                    'https://player.vimeo.com/video/' +
                    videoId +
                    '?title=0&byline=0&portrait=0';
                //let videoUri = res.data.uri;
                //let videoLink = res.data.link;
                let uploadLink = '';
                console.log(res.data, res.data.upload, res.data.upload.upload_link)
                if (res.data && res.data.upload && res.data.upload.upload_link) {
                    uploadLink = res.data.upload.upload_link;
                }


                let saveUploadLink = '';
                saveUploadLink = await Vue.axios.put(API_URL + type + 's/' + participation.id, {
                    video_upload_link: uploadLink,
                    video_id: videoId,
                }, {
                    headers: {token: rootState.token},
                });
                upload_link = uploadLink;
                console.log('SAVE', saveUploadLink)
            } else {
                videoId = participation.video_id
                linkToSaveInPlanner =
                    'https://player.vimeo.com/video/' +
                    videoId +
                    '?title=0&byline=0&portrait=0';
                upload_link = participation.video_upload_link

                console.log('link aus db', upload_link)
            }

            // The upload URL you get from the Vimeo API for uploading
            var uploadUrl = await upload_link;
            console.log('TUS URL', uploadUrl)
            let tusUpload = '';
            var options = {
                uploadUrl: uploadUrl,
                retryDelays: [0, 1000, 3000, 5000],
                chunkSize: 5000000, //5MB
                metadata: {
                    filename: state.videoName,
                    filetype: state.videoFile.type
                },
                headers: {
                    Accept: 'application/vnd.vimeo.*+json;version=3.4'
                },
                onError: function (error) {
                    console.log('Error');
                    console.log(error);
                },
                onProgress: function (bytesUploaded, bytesTotal) {
                    state.uploaded = bytesUploaded;
                    state.total = bytesTotal;
                    var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
                    state.percentage = percentage;
                    console.log(bytesUploaded, bytesTotal, percentage + '%');
                },
                onSuccess: async function (resp) {
                    console.log(resp)
                    let headers = {
                        Authorization: 'bearer ' + VUE_APP_VIMEO_ACCESS_TOKEN,
                        Accept: 'application/vnd.vimeo.*+json;version=3.4',
                        'Content-Type': 'application/json'
                    };

                    let folder = await vimeoAxios({
                        method: 'PUT',
                        url:
                            'https://api.vimeo.com/me/projects/' +
                            VUE_APP_VIMEO_FOLDER_ID +
                            '/videos/' +
                            videoId,
                        headers: headers
                    });
                    console.log(folder)
                    /*let preset = await vimeoAxios({
                        method: 'PUT',
                        url:
                        'https://api.vimeo.com/videos/' +
                        videoId +
                        '/presets/' +
                        process.env.VUE_APP_VIMEO_EMBED_PRESET_ID,
                        headers: headers
                    });*/

                    console.log('successfully uploaded');

                    if (type == 'session') {
                        await Vue.axios.put(API_URL + type + 's/' + participation.id, {
                            ondemand_link: linkToSaveInPlanner,
                            video_id: null,
                            video_upload_link: null
                        }, {
                            headers: {token: rootState.token},
                        });
                        participation.ondemand_link = linkToSaveInPlanner;
                    }
                    if (type == 'presentation') {
                        await Vue.axios.put(API_URL + type + 's/' + participation.id, {
                            video_link: linkToSaveInPlanner,
                            video_id: null,
                            video_upload_link: null
                        }, {
                            headers: {token: rootState.token},
                        });
                        participation.video_link = linkToSaveInPlanner;
                    }

                    participation.video_upload_link = null;
                    state.percentage = 0;
                    state.uploaded = 0;
                    state.total = 0;
                    state.uploadStarted = false;
                }
            };
            tusUpload = new tus.Upload(file, options);
            tusUpload.start();
        },


        async checkVideoStatus({state}, link) {
            let id = link.split('?')[0].split('/').pop();
            let videoCreate = Vue.axios.create();
            delete videoCreate.defaults.headers.common['Access-Token'];
            delete videoCreate.defaults.headers.common['x-api-key'];
            delete videoCreate.defaults.headers.common['X-CSRF-TOKEN'];
            delete videoCreate.defaults.headers.common['X-Requested-With'];

            let res = await videoCreate({
                method: 'GET',
                url: 'https://api.vimeo.com/videos/' + id + '?fields=uri,upload.status,transcode.status',
                headers: {
                    Authorization: 'bearer ' + VUE_APP_VIMEO_ACCESS_TOKEN,
                    Accept: 'application/vnd.vimeo.*+json;version=3.4',
                    'Content-Type': 'application/json'
                }

            });
            let transcode_status = res.data.transcode.status;

            Vue.set(state.transcodeStatus, link, transcode_status);

            console.log(state.transcodeStatus)
        }
    }
}
